// The features a creator can add, as the dashboard and sites describe them (see experiences.ts),
// with no schema library, so a creator site's script stays small.

export const experienceCatalog = [
  {
    kind: "training",
    featureFlag: "components.training",
    name: "Training",
    label: "Your training, their progress",
    description:
      "Publish exercises, workouts and programs. Members plan sessions, log their training and see their progress.",
    route: "/training",
    color: "var(--paper)",
    features: ["Programs and workouts", "Exercise videos", "Calendar and progress"],
  },
  {
    kind: "shop",
    featureFlag: "components.shop",
    name: "Merch",
    label: "Your creations, out in the world",
    description: "Sell products and merch, or connect your existing store.",
    route: "/merch",
    color: "var(--paper)",
    features: ["Products and variants", "Managed printing", "Fourthwall products"],
  },
  {
    kind: "tournaments",
    featureFlag: "components.tournaments",
    name: "Tournaments",
    label: "Your events, together",
    description: "A read-only event home with verified start.gg source links.",
    route: "/tournaments",
    color: "var(--paper)",
    features: ["Upcoming tournaments", "Event details", "Registration links"],
  },
  {
    kind: "booking",
    featureFlag: "components.booking",
    name: "Appointments",
    label: "Your time, booked",
    description: "Offer services, set your availability, and accept paid appointments.",
    route: "/booking",
    color: "var(--paper)",
    features: ["Availability", "Guest booking", "Online payments"],
  },
  {
    kind: "library",
    name: "Content library",
    label: "Your home for everything",
    description:
      "Bring your posts, videos, galleries, and downloads together in a browsable member library.",
    route: "/library",
    color: "#e5ede4",
    features: ["Collections", "Member access", "Mixed media"],
  },
  {
    kind: "blog",
    name: "Posts",
    label: "Make room for your ideas",
    description:
      "A clean editorial home for essays, updates, and long-form posts. Publish once, share everywhere.",
    route: "/blog",
    color: "#f4e9d8",
    features: ["Editorial layout", "Post archive", "Member stories"],
  },
  {
    kind: "matchups",
    name: "League matchups",
    label: "Your knowledge, playable",
    description:
      "Turn your champion expertise into a searchable guide, with matchup difficulty, lane advice, runes, and builds.",
    route: "/matchups",
    color: "#e8e5f3",
    features: ["Champion guide", "Difficulty filters", "Runes & builds"],
  },
  {
    kind: "bible",
    name: "League Bible",
    label: "The complete champion playbook",
    description:
      "Teach your champion in six focused chapters: builds, runes, abilities, mechanics, carrying, and synergies.",
    route: "/bible",
    color: "#e3ead4",
    features: ["Six chapters", "Structured lessons", "Chapter access"],
  },
  {
    kind: "community",
    name: "Community",
    label: "Give members a place to belong",
    description:
      "A private member feed for updates, questions, threaded replies, likes, and an optional Discord invitation.",
    route: "/community",
    color: "#e1ece8",
    features: ["Member posts", "Threaded replies", "Likes & moderation"],
  },
  {
    kind: "coaching",
    name: "Coaching",
    label: "Turn your time into a bookable offer",
    description:
      "Give coaching a focused home and let visitors reserve available time through your Calendly or Cal.com calendar.",
    route: "/coaching",
    color: "#ece5f4",
    features: ["Calendly or Cal.com", "Dedicated landing page", "Creator-owned offer"],
  },
] as const;
